import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { Container } from '@mui/material';

import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';

import { NavigationBar, Page, PageContent, Typography } from '@ocx/ui';

import { allureCashbackMessages } from './allure-cashback.messages';

type AllureCashbackLayoutProps = {
  children: ReactNode;
};

export const AllureCashbackLayout = ({ children }: AllureCashbackLayoutProps) => {
  return (
    <Page>
      <HtmlTitle title={allureCashbackMessages.htmlTitle} />
      <NavigationBar
        left={<BackButton />}
        center={
          <Typography component="h2">
            <FormattedMessage {...allureCashbackMessages.navigationBarTitle} />
          </Typography>
        }
      />
      <PageContent bgcolor="background.paper">
        <Container maxWidth="xs" disableGutters sx={{ display: 'flex', flexDirection: 'column', flex: 1, px: 0 }}>
          {children}
        </Container>
      </PageContent>
    </Page>
  );
};
